export enum Urls {
  Halls = "/halls",
  AvailableSlots = "/halls/:hallId/slots",
  AvailableDates = "/halls/:hallId/dates",
  Equipment = "/booking/equipment/available",
  EquipmentKits = "/booking/equipment/defaults",
  Booking = "/booking",
  BookingById = "/booking/:bookingId",
  PromoCode = "/booking/validate/promocode",
}
